const Footer = () => {
  return (
    <footer>
      <p>Created by Jessica Handrahan at Juno College 2023©</p>
    </footer>
  );
};
export default Footer;
